// extracted by mini-css-extract-plugin
export var divider = "_nt-0";
export var systemMessage = "_nt-1";
export var systemMessageWrapper = "_nt-2";